import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SuscripcionesPlanes } from '../../components/SuscripcionesPlanes/SuscripcionesPlanes';
import './suscripciones.css';
import './ui-suscripciones.css';
import { IconCalcPrecios } from '../../components/Icons/IconCalcPrecios';
import { IconCompPrecios } from '../../components/Icons/IconCompPrecios';
import { IconPack } from '../../components/Icons/IconPack';
import { IconPending } from '../../components/Icons/IconPending';
import CustomToolTip from '../../core/CustomToolTip/CustomToolTip';
import {
	ProductChildViewModel,
	ProductViewModel,
	ProductViewModelCollectionResult,
	SubscriptionUserViewModel,
	postApiSubscription,
	postApiSubscriptionProducts,
} from '../../api';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';
import { usePacksUser } from './useUserPacks';
import Header from '../../components/Header/Header';
import { IconPro } from '../../components/Icons/IconPro';
import { IconHelp } from '../../components/Icons/IconHelp';
import ModalCalculadora from '../../components/Modals/ModalCalculadora';
import ModalComparador from '../../components/PriceComparator/ModalComparador';

export const SuscripcionesPage = () => {
	const { t, i18n } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const [packActive, setPackActive] = useState<boolean>(false);
	const [products, setProducts] = useState<ProductViewModel[]>([]);
	const [loading, setLoading] = useState<boolean>(true); // Estado para controlar el loading
	const [activeTab, setActiveTab] = useState<string>(''); // Estado para el tab activo
	const [childProducts, setChildProducts] = useState<ProductChildViewModel[]>([]); // Estado para los childProducts

	const [packs, setPacks] = useState<SubscriptionUserViewModel[]>([]);
	const [isModalCalculadoraOpen, setIsModalCalculadoraOpen] = useState(false);
	const [isModalComparadorOpen, setIsModalComparadorOpen] = useState(false);

	const userId = localStorage.getItem('userId') || '';
	const productParentName = activeTab;

	// Find the product ID based on the name
	const selectedProduct = products.find((product) => product.name === productParentName);
	const productParentId = selectedProduct?.id ?? -1;

	const { packsUser, loadingUser, error, refetch } = usePacksUser(userId, productParentId);
	console.log('🚀 ~ SuscripcionesPage ~ packsUser:', packsUser);

	const productIdsUses = packsUser.map((item) => item.product.id);

	const handleButtonClick = () => {
		setIsOpen(true); // Asegúrate de abrir el pop-up al hacer clic
		// setPackActive(true);
	};

	const handleClosePopUp = () => {
		setIsOpen(false); // Permite que el pop-up se cierre
	};

	const handleTabClick = (productName: string) => {
		setActiveTab(productName); // Cambia el tab activo

		// Encontramos el producto que corresponde al tab seleccionado
		const selectedProduct = products.find((product) => product.name === productName);

		if (selectedProduct) {
			// Asignamos los childProducts del producto seleccionado
			setChildProducts(selectedProduct.childProducts || []);
		}
	};

	useEffect(() => {
		postApiSubscriptionProducts()
			.then((data: ProductViewModelCollectionResult) => {
				if (data.results) {
					setProducts([...data.results]);
					setLoading(false); // Termina el loading

					const firstProduct = data.results[0];
					const firstName = firstProduct?.name ?? '';

					setActiveTab(firstName);

					// Luego de actualizar `activeTab`, establece los `childProducts`
					setChildProducts(firstProduct?.childProducts ?? []);
				}
			})
			.catch((error) => console.error('Error al cargar los productos:', error));
	}, []);

	const calculateDaysRemaining = (expirationDate: string, isPending: boolean = false) => {
		const today = new Date();
		const expDate = new Date(expirationDate);
		if (!isPending) {
			expDate.setFullYear(expDate.getFullYear() + 1); // Añade un año a la fecha de expiración solo si no está pendiente
		}
		const diffTime = expDate.getTime() - today.getTime();
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		return diffDays > 0 ? `${diffDays} ${t('suscripcion.lists_packs.days')}` : t('suscripcion.lists_packs.expired');
	};

	if (loading) {
		return <CircularLoading />;
	}
	if (error) return <p>{error}</p>;

	return (
		<>
			<Header>
				<h2 className="title_suscripciones">{t('suscripcion.title')}</h2>
			</Header>
			<div className="suscripciones_page">
				<p className="desc_suscripciones">{t('suscripcion.description')}</p>
				<div className="container_suscripciones">
					<div className="suscripciones_head">
						<div className="suscripciones_head_left">
							{products.map((product) =>
								product.name === 'Price Calculator' || product.name === 'Price Comparator' ? (
									<div
										key={product.id}
										className={`suscripciones_head_item ${activeTab === product.name ? 'suscripciones_head_item--active' : ''}`}
										onClick={() => handleTabClick(product.name ?? '')} // Asigna la función al clic
									>
										<div className="suscripciones_head_icon">
											{product.name === 'Price Calculator' ? <IconCalcPrecios /> : <IconCompPrecios />}
										</div>
										<span className="suscripciones_head_text">
											{t(
												product.name === 'Price Calculator'
													? 'suscripcion.title_calculadora'
													: 'suscripcion.title_comparador',
											)}
										</span>
									</div>
								) : null,
							)}
						</div>
						<div className="suscripciones_head_right">
							<button
								className="suscripciones_head_button"
								onClick={handleButtonClick}
								type="button">
								{t('suscripcion.button')}
							</button>
						</div>
					</div>

					{loadingUser ? (
						<div className="suscripciones__loading">
							<CircularLoading />
						</div>
					) : packsUser.length === 0 ? (
						<div className="suscripciones_empty">
							{activeTab === 'Price Calculator' ? (
								<>
									<h3 className="suscripciones_empty_title">
										{t(`suscripcion.empty_packs.price_calculator.title`)}{' '}
										<span className="suscripciones_empty_title_span">
											<IconPro
												fill="#1A2228"
												width={15}
												height={12}
											/>
										</span>
									</h3>
									<span className="suscripciones_empty_text">
										{t(`suscripcion.empty_packs.price_calculator.description`)}
									</span>
									<div className="suscripciones_empty_buttons">
										<button
											className="suscripciones_empty_button"
											onClick={handleButtonClick}
											type="button">
											{t(`suscripcion.empty_packs.price_calculator.button`)}
										</button>
										<button
											className="suscripciones_empty_button_why_pro"
											onClick={() => setIsModalCalculadoraOpen(true)}
											type="button">
											{t(`suscripcion.empty_packs.price_calculator.why_pro`)}
											<IconHelp
												fill="#ECEEEF"
												width={15}
												height={12}
											/>
										</button>
									</div>
								</>
							) : (
								<>
									<h3 className="suscripciones_empty_title">
										{t(
											`suscripcion.empty_packs.${activeTab === 'Price Calculator' ? 'price_calculator' : 'comparador'}.title`,
										)}
									</h3>
									<span className="suscripciones_empty_text">
										{t(
											`suscripcion.empty_packs.${activeTab === 'Price Calculator' ? 'price_calculator' : 'comparador'}.description`,
										)}
									</span>
									<button
										className="suscripciones_empty_button"
										onClick={handleButtonClick}
										type="button">
										{t(
											`suscripcion.empty_packs.${activeTab === 'Price Calculator' ? 'price_calculator' : 'comparador'}.button`,
										)}
									</button>
								</>
							)}
						</div>
					) : (
						<div className="table_packs_overflow">
							<div className="table_packs">
								<div className="table_packs_row table_packs_row_head">
									<div className="table_packs_col table_packs_col_icon"></div>
									<div className="table_packs_col table_packs_col_package">
										<span className="table_packs_col_title">{t('suscripcion.table.title_1')}</span>
									</div>
									<div className="table_packs_col table_packs_col_total">
										<span className="table_packs_col_title">{t('suscripcion.table.title_2')}</span>
									</div>
									<div className="table_packs_col table_packs_col_date">
										<span className="table_packs_col_title">{t('suscripcion.table.title_3')}</span>
									</div>
									<div className="table_packs_col table_packs_col_expires">
										<span className="table_packs_col_title">{t('suscripcion.table.title_4')}</span>
									</div>
									<div className="table_packs_col table_packs_col_remaining">
										<span className="table_packs_col_title">{t('suscripcion.table.title_5')}</span>
									</div>
									<div className="table_packs_col table_packs_col_lkn"></div>
								</div>

								{packsUser.map((pack) => {
									const subscriptionState = (pack.subscriptionState || '').toLowerCase();
									const state = ((pack as any).state || '').toLowerCase();
									const paymentStatus = (pack.paymentStatus || '').toLowerCase();
									const internalStatus = ((pack as any).internalStatus || '').toLowerCase();

									// ACTIVE: Solo si cumple una de estas condiciones
									const isActive =
										(state === 'sale' && subscriptionState === 'active') ||
										(state === 'sent' && subscriptionState === 'active') ||
										(state === 'sale' && subscriptionState === 'pending' && paymentStatus === 'paid') ||
										(state === 'sent' && subscriptionState === 'pending' && paymentStatus === 'paid');

									// USED: Si cumple una de estas condiciones
									const isUsed =
										internalStatus === 'used' ||
										(pack.remainingUses !== null && pack.remainingUses === 0) ||
										state === 'done' ||
										state === 'closed' ||
										(state === 'sale' && subscriptionState === 'closed') ||
										(state === 'sent' && subscriptionState === 'closed');

									// CANCELED: Si cumple una de estas condiciones
									const isCanceled = state === 'cancel' || subscriptionState === 'cancel';

									// PENDING PAYMENT: Resto de casos
									const isPendingPayment = !isActive && !isUsed && !isCanceled;

									// Determinar la clase CSS basada en el estado
									let statusClass = '';
									if (isUsed) statusClass = 'used';
									else if (isActive) statusClass = 'active';
									else if (isCanceled) statusClass = 'canceled';
									else if (isPendingPayment) statusClass = 'pending';

									return (
										<div
											key={pack.id}
											className={`table_packs_row table_packs_row_filled ${statusClass}`}>
											<div className="table_packs_col table_packs_col_icon">
												<div className="table_packs_icon_circle">
													{isPendingPayment ? <IconPending /> : <IconPack className="table_packs_icon_svg" />}
												</div>
											</div>
											<div className="table_packs_col table_packs_col_package">
												<span className="table_packs_package">{pack.product?.name}</span>
											</div>
											<div className="table_packs_col table_packs_col_total">
												<span className="table_packs_total">
													{pack.product?.uses} {t('suscripcion.lists_packs.calculations')}
												</span>
											</div>
											<div className="table_packs_col table_packs_col_date">
												{isPendingPayment ? (
													<CustomToolTip
														title=""
														tooltipText={t('suscripcion.lists_packs.payment_status_tooltip')}>
														<span className="table_packs_date">{t('suscripcion.lists_packs.payment_status')}</span>
													</CustomToolTip>
												) : (
													<span className="table_packs_date">
														{new Date(pack.dateOrder || '').toLocaleDateString(i18n.language, {
															day: '2-digit',
															month: 'long',
															hour: '2-digit',
															minute: '2-digit',
														})}
													</span>
												)}
											</div>
											<div className="table_packs_col table_packs_col_expires">
												{!isCanceled && !isUsed && !isPendingPayment && (
													<span className="table_packs_expires">
														{pack.dateOrder && calculateDaysRemaining(pack.dateOrder, false)}
													</span>
												)}

												{isPendingPayment && (
													<span className="table_packs_expires">
														{pack.subscriptionExpirationDate &&
															calculateDaysRemaining(pack.subscriptionExpirationDate, true)}
													</span>
												)}

												{isCanceled && !isPendingPayment && (
													<span className="table_packs_expires">{t('suscripcion.lists_packs.expired')}</span>
												)}
												{isUsed && !isPendingPayment && !isCanceled && (
													<span className="table_packs_expires">{t('suscripcion.lists_packs.used')}</span>
												)}
											</div>
											<div className="table_packs_col table_packs_col_remaining">
												{!isPendingPayment && !isCanceled && (
													<span className="table_packs_remaining">
														{pack.remainingUses === null && isActive ? pack.product?.uses : (pack.remainingUses ?? 0)}{' '}
														{t('suscripcion.lists_packs.available_uses')}
													</span>
												)}
												{isCanceled && !isPendingPayment && (
													<span className="table_packs_remaining">{t('suscripcion.lists_packs.canceled')}</span>
												)}
											</div>
											<div className="table_packs_col table_packs_col_lkn"></div>
										</div>
									);
								})}
							</div>
						</div>
					)}
				</div>
			</div>
			<ModalCalculadora
				isOpen={isModalCalculadoraOpen}
				onClose={() => setIsModalCalculadoraOpen(false)}
				onOpenPacks={() => {
					setIsModalCalculadoraOpen(false);
					setIsOpen(true);
				}}
				onShowLogin={() => setIsModalCalculadoraOpen(false)}
			/>
			<ModalComparador
				isOpen={isModalComparadorOpen}
				onClose={() => setIsModalComparadorOpen(false)}
				onViewPacks={() => {
					setIsModalComparadorOpen(false);
					setIsOpen(true);
				}}
			/>
			<SuscripcionesPlanes
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				onClose={handleClosePopUp}
				data={childProducts}
				productIdsUses={selectedProduct?.name === 'Price Calculator' ? productIdsUses : []}
				refetch={refetch}
				productParentName={productParentName}
				onBackToPopup={() => {
					setIsOpen(false);
					if (productParentName === 'Price Calculator') {
						setIsModalCalculadoraOpen(true);
					} else {
						setIsModalComparadorOpen(true);
					}
				}}
			/>
		</>
	);
};
